export default class ScrollModule {
  constructor(controller) {
    this.controller = controller;
  }

  initialize() {
    this.initScrollButtons();
  }

  initScrollButtons() {
    // Implementação dos botões de navegação horizontal para múltiplos containers
    // Associar cada botão ao container correspondente
    this.controller.scrollLeftTargets.forEach((leftButton, index) => {
      const rightButton = this.controller.scrollRightTargets[index];
      const container = this.controller.escalasContainerTargets[index];

      if (container && rightButton) {
        leftButton.addEventListener("click", () => {
          container.scrollBy({ left: -300, behavior: "smooth" });
        });

        rightButton.addEventListener("click", () => {
          container.scrollBy({ left: 300, behavior: "smooth" });
        });
      }
    });
  }
}
